const mEditionMapPathTreeNodeActionsActivationImmediate = {
  mEditionMapPathTreeNodeActionsActivationImmediate: {
    messages: {
      daysAfter: 'Días despúes',
      inmediate: 'Inmediato',
      notActivated: 'No Activado'
    }
  }
}

export default mEditionMapPathTreeNodeActionsActivationImmediate
